import { apiErrorFromResponse } from './apiError';
import { isPasskeyStepUpError, performAutomaticPasskeyStepUp } from './passkeyStepUp';
export async function fetchWithPasskeyStepUp(input, init) {
    let retriedAfterStepUp = false;
    while (true) {
        const response = await fetch(input, init);
        if (response.ok)
            return response;
        const error = await apiErrorFromResponse(response);
        if (!retriedAfterStepUp && isPasskeyStepUpError(error)) {
            retriedAfterStepUp = true;
            await performAutomaticPasskeyStepUp();
            continue;
        }
        throw error;
    }
}
export default fetchWithPasskeyStepUp;
